'use strict';
var Dispatcher = require('../dispatcher/appDispatcher');
var ActionType = require('../constants/actionType');

module.exports = {
  registerError: function (error) {
    Dispatcher.dispatchAsync({
      actionType: ActionType.APP_ERROR,
      error: error
    });
  }
};
